<script>
    import Topbar from '../components/molecules/Topbar/Topbar.svelte';
    import ProfileHeader from '../components/molecules/Profile/ProfileHeader.svelte';
    import ProfileStats from '../components/molecules/Profile/ProfileStats.svelte';
    import ProfileLinks from '../components/molecules/Profile/ProfileLinks.svelte';
    import { modalCanUseHistoryBack } from '../store';
  
    // This checks, wether another route (like this one) was opened, before the modal was opened.
    // When opening a deeplink to a modal directly, this remains false and therefore closing the overlay will not use history.back() (e.g. to prevent going back to google.com), instead it just routes to "/"
    $modalCanUseHistoryBack = true;
</script>
<style>
    .profile {
        flex: 1;
        margin: 0;
    }
</style>
<Topbar></Topbar>
<section class="profile">
    <ProfileHeader></ProfileHeader>
    <ProfileStats></ProfileStats>
    <ProfileLinks></ProfileLinks>
</section>